
export default {
  props: {
    header: {
      type: String,
      required: true
    },
    firstText: {
      type: String,
      required: true
    },
    secondText: {
      type: String,
      required: true
    },
    thirdText: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      required: true
    },
    crop: {
      type: String,
      default: 'right'
    }
  },
  computed: {
    tabletImage () {
      return `${this.image}?ar=1.25:1&fit=crop&crop=${this.crop}`;
    }
  }
};
